import React, { useEffect, useState } from "react";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import ICONS from "../../../assets/Icons";
import { useNavigate } from "react-router-dom";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import CommonToast from "../../_utils/CommonToast";

const FieldForceRequestMultiApprovalDeclined = () => {
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const lengthVarForConditonOne = GlobalConfiguration.lengthCheckOne;

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementRequestTxnData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const buttonRows = [
    [
      {
        btnText: "Approve more requests",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/field_force_transaction_dashboard/field_force_request_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/field_force_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            // navigate(
            //   `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${account?.request_id}`,
            // )
            CommonToast({
              text: "Feature coming soon",
              icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
              variant: "var(--coming-soon)",
              buttonNeeded: false,
            })
          }
          rows={[
            {
              leftTitle: account?.field_force_account_name
                ?.toLowerCase()
                .split(" ")
                .map(
                  (w) =>
                    w
                      .charAt(GlobalConfiguration.lengthCheckZero)
                      .toUpperCase() +
                    w.slice(GlobalConfiguration.lengthCheckOne),
                )
                .join(" "),
              leftSubTitle: "Account name",
              rightTitle: (
                <>
                  INR{" "}
                  <FormatAmount
                    price={account?.requested_amount ?? account?.amount}
                  />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              hasRight: true,
              rightIcon: true,
              rightText: true,
              onClick: () =>
                // navigate(
                //   `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${account?.request_id}`,
                // ),
                CommonToast({
                  text: "Feature coming soon",
                  icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                  variant: "var(--coming-soon)",
                  buttonNeeded: false,
                }),
            },
          ]}
        />
      ))}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={declinedPageID?.length && "Requests rejected successfully."}
    >
      <TabsWeapperSection
        title={`Rejected - ${
          declinedPageID?.length || declinedPageData?.length
        }`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default FieldForceRequestMultiApprovalDeclined;
